import { render } from "./museum.vue?vue&type=template&id=0f3460ca&scoped=true"
const script = {}

import "./museum.vue?vue&type=style&index=0&id=0f3460ca&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3460ca"]])

export default __exports__